import { ORDER_TYPES } from '../../../viewmodels'

/**
 * Gets the dropdown value for a given billing type code (e.g., 'bill-to-patient' -> '2')
 * @param billingTypeCode - The billing type code from partner config (e.g., 'bill-to-patient', 'bill-to-client')
 * @returns The dropdown value or null if not found
 */
export const getValueFromBillingTypeCode = (billingTypeCode: string): string | null => {
  const orderType = Object.values(ORDER_TYPES).find((type) => type.code === billingTypeCode)
  return orderType?.value ?? null
}

export const generatePaymentMethodDropdownOptions = (partnerConfig: any) => {
  const paymentMethodOptions = []
  const enabledBillingTypes = partnerConfig?.enabled_billing_types ?? []

  // Bill to Patient
  const billToPatient = ORDER_TYPES['Bill to Patient']
  paymentMethodOptions.push({
    text: billToPatient.text,
    value: billToPatient.value,
    label: billToPatient.text,
    disabled: !enabledBillingTypes.includes(billToPatient.code),
    disabledReason: ``,
  })

  // Bill to Client
  const billToClient = ORDER_TYPES['Bill to Client']
  paymentMethodOptions.push({
    text: billToClient.text,
    value: billToClient.value,
    label: billToClient.text,
    disabled: !enabledBillingTypes.includes(billToClient.code),
    disabledReason: !enabledBillingTypes.includes(billToClient.code)
      ? `Bill to Client is not available for selection. Contact operationssuport@labsavvy.com for more information.`
      : ``,
  })

  // Bill to Insurance - add here when the time comes

  return paymentMethodOptions
}
